module.exports = __webpack_public_path__ + "img/background-exp.3239b2a4.jpg";